import React from "react";
interface QAInter {
    li?: any;
    question?: any;
}
const QA: React.FC<QAInter> = ({ li, question }) => {
    return (
        <section className="my-9">
            <h2 className="casestudy-header font-normal">{question}</h2>
            <ul className={`${li.length === 1 ? "px-0" : ""}`}>
                {li.map((item: any) => {
                    return <div style={{ fontSize: "20px" }} key={item} dangerouslySetInnerHTML={{ __html: item }} />;
                })}
            </ul>
        </section>
    );
};

export default QA;
